import type { Report } from '../types';

export const getScheduledReportEditState = (
  mode: 'create' | 'update',
  report?: Report
) => ({
  active: mode === 'create' ? true : (report?.active ?? true),
  dayOfWeek: mode === 'create' ? 1 : (report?.dayOfWeek ?? 1),
});
